import { render } from "./UeMaterialsEditView.vue?vue&type=template&id=70c888d3&scoped=true"
import script from "./UeMaterialsEditView.vue?vue&type=script&lang=js"
export * from "./UeMaterialsEditView.vue?vue&type=script&lang=js"

import "./UeMaterialsEditView.vue?vue&type=style&index=0&id=70c888d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c888d3"]])

export default __exports__